import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import DriverRegisterForm from "@/components/auth/DriverRegisterForm";
import { authService } from "@/services/authService";
import { RegisterCredentials } from "@/types/auth";

export default function DriverRegisterPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const vehicleType =
    (searchParams.get("type") as "delivery" | "scooter" | "taxi") || "taxi";

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();

  const handleDriverRegister = async (data: RegisterCredentials) => {
    setIsLoading(true);
    setError(undefined);

    try {
      // Use real authentication service for driver registration
      const response = await authService.register({
        ...data,
        role: "driver", // Set role as driver
      });

      if (response.success && response.token) {
        // Store token and redirect to driver dashboard
        localStorage.setItem("auth_token", response.token);
        navigate("/dashboard/driver/dashboard");
      } else {
        setError(response.message || "Registration failed. Please try again.");
      }
    } catch (err: any) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // Handle Google OAuth for driver registration
    console.log("Google driver registration");
  };

  return (
    <DriverRegisterForm
      error={error}
      isLoading={isLoading}
      onGoogleLogin={handleGoogleLogin}
      onSubmit={handleDriverRegister}
      vehicleType={vehicleType}
    />
  );
}
